import PropTypes from 'prop-types';
import Colors from '../colors';
const defaultTextProps = {
  children: '',
  color: Colors.gray600,
  align: 'left',
  textDecorationLine: 'none',
  onPress: undefined,
  href: undefined
};
const defaultTextPropTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  textDecorationLine: PropTypes.oneOf(['none', 'underline', 'line-through', 'underline line-through']),
  onPress: PropTypes.func,
  href: PropTypes.string
};
export { defaultTextProps, defaultTextPropTypes };
//# sourceMappingURL=default-text-props.js.map